import React, { FC, useEffect, useState } from 'react'
import { ComponentBlogFeaturedResource } from '../../../models/components/blogFeaturedResource'
import { generateAdData } from '../../../utils/functions.utils'
import { BlogFeaturedResourceContainer } from './style'
import { FeaturedResource } from './subcomponents'

type Props = {
  data: ComponentBlogFeaturedResource
}

const BlogFeaturedResource: FC<Props> = ({ data }) => {
  const [featuredResource, setFeaturedResource] = useState<any>(null)

  useEffect(() => {
    if (data) {
      setFeaturedResource(generateAdData(data))
    }
  }, [])

  const hasImage = featuredResource?.image ? true : false
  return featuredResource ? (
    <BlogFeaturedResourceContainer data-cy="blogFeaturedResource" $hasImage={hasImage}>
      <FeaturedResource featuredResource={featuredResource} />
    </BlogFeaturedResourceContainer>
  ) : null
}

export default BlogFeaturedResource
